import { Table } from "semantic-ui-react";

import TableCell from "./TableCell";

export default function TableHeaderCell(props) {
	return <TableCell as={Table.HeaderCell} {...props} />;
}
